module.exports = __webpack_public_path__ + "assets/merriweather-italic.7822ac096236bd0ae2091adc446fad23e1b7472f5df48a68037b4c7e6ae9d6e2.woff2";